import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CfetBaseComponent, CfetPageNamesConstant } from '../../../cfet-core';
import { environment } from './../../../../environments/environment';

@Component({
    selector: 'app-customer-cancel-modal',
    templateUrl: './customer-cancel-modal.component.html',
    styleUrls: ['./customer-cancel-modal.component.scss'],
    standalone: false
})
export class CustomerCancelModalComponent extends CfetBaseComponent {

  @Input() openModal: string;
  @Output() closeCancelModal = new EventEmitter<any>();
  constructor() { super(); }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method

  closeModal(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' ||
      event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.closeCancelModal.emit('modalClose');
    }
  }

  cancelAppln(event, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.closeCancelModal.emit('modalClose');
      const url = environment.getBrowserPath() + CfetPageNamesConstant.CUSTOMER_LANDING;
      this.redirectUrl(url);
      sessionStorage.clear();
    }
  }

  redirectUrl(url) {
    window.location.href = url;
  }

}
